
import { useDispatch } from 'react-redux';
import moment from 'moment'
import UserApi from '../services/UserApi';
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";



export const useGlobalFunc = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch();

  const setLoading = async (status) => {
    if (status == true) {
      dispatch({
        type: "UPDATE_LOADING",
        payload: { loading: true }
      });
    }
    else {
      dispatch({
        type: "UPDATE_LOADING",
        payload: { loading: false }
      });
    }

  };

  const updateMe = async () => {
    if (localStorage.getItem('userToken')) {
      try {
        let res = await UserApi.me()
        dispatch({
          type: "UPDATE_USERINFO",
          payload: { userInfo: res.data.data }
        });
      }
      catch (errors) {
        console.log('removeToken')
        localStorage.removeItem("userToken")
        window.location.reload()
        //errorToast(errors?.response?.data?.message || errors.toString())
      }
    }
  };

  function successToast(message) {
    console.log(message)
    return toast.success(t(message))
    //toast.success(t(message))
  }

  function errorToast(message) {
    console.log(message)
    return toast.error(t(message))
    // toast.error(t(message))
  }
  function alertDialog(message) {
    console.log(message)
    dispatch({
      type: "UPDATE_ALERTDIALOG",
      payload: { alertDialog: { isOpen: true, content: message } }
    });
    return
    // toast.error(t(message))
  }



  return { updateMe, setLoading, successToast, errorToast,alertDialog };

};

export function numberToChinese(number) {
  const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const unit = ['', '十', '百', '千'];

  if (number === 0) {
    return '零';
  }

  let result = '';
  let numStr = number.toString();

  for (let i = 0; i < numStr.length; i++) {
    const digit = parseInt(numStr[i]);

    if (digit !== 0) {
      result += chineseNumbers[digit - 1] + unit[numStr.length - 1 - i];
    } else {
      // 处理零的情况，避免连续多个零
      if (i < numStr.length - 1 && parseInt(numStr[i + 1]) !== 0) {
        result += '零';
      }
    }
  }

  return result;
}

export function currentColorStyle(color) {
  return {
      borderColor: color,
      color: color
  }
}

export function time2date(date) {
  return moment(date).format("YYYY-MM-DD")
}
export function time2date2(date) {
  return moment(date).format("YYYY-MM-DD HH:mm:ss")
}


export function checkEventStatus(start, end) {
  let toStart = moment(start).valueOf() - moment().valueOf()
  let toEnd = moment(end).valueOf() - moment().valueOf()

  if (toStart > 0) {
    return "即將開始"
    return `${Math.floor(toStart / 86400000)}天後開始`
  }
  else if (toEnd > 0) {
    return `最後${Math.floor(toEnd / 86400000)}天`
  }
  else {
    return `已完結`
  }
  //return moment(end).valueOf()

}


export function separatorNumber(numb) {
  var str = numb.toString().split(".");
  str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return str.join(".");
}



